/* @flow */

import React from 'react';
import styled from '@emotion/styled';
import { get } from 'lodash/fp';
import { padding } from 'polished';

import t from 'app/utils/translate';

type Props = {
  className?: string,
  kind?: 'info' | 'success' | 'danger' | 'warning',
  label: string
};

const defaultProps = {
  className: undefined,
  kind: 'info'
};

const Wrapper = styled.div(({ theme, kind }) => ({
  backgroundColor: get(kind, theme.color),
  borderRadius: 3,
  fontSize: 10,
  lineHeight: 1.4,
  color: theme.color.white,
  // $FlowIgnore
  ...padding(2, 4, '0'),
  textTransform: 'uppercase'
}));

function Pill({ className, label, kind }: Props) {
  return (
    <Wrapper className={className} kind={kind}>
      {t(label)}
    </Wrapper>
  );
}

Pill.defaultProps = defaultProps;

export default Pill;
